import React, { useEffect, useRef } from "react"
import { Input } from "antd"

const OtpInput = ({
  value = "",
  onChange,
  onEnter,
  length = 6,
  disabled = false,
}) => {
  const inputsRef = useRef([])

  useEffect(() => {
    if (!disabled && inputsRef.current[0]) {
      inputsRef.current[0].focus()
    }
  }, [disabled])

  const updateValue = (newValue) => {
    onChange(
      newValue
        .replace(/\D/g, "")
        .slice(0, length)
    )
  }

  const handleChange = (inputValue, index) => {
    const digit = inputValue
      .replace(/\D/g, "")
      .slice(-1)

    const otpArray = value.padEnd(length, "").split("")
    otpArray[index] = digit

    const newOtp = otpArray.join("")

    updateValue(newOtp)

    if (digit && index < length - 1) {
      if (inputsRef.current[index + 1]) {
        inputsRef.current[index + 1].focus()
      }
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter") {
      e.preventDefault()

      if (value.length === length && !disabled) {
        if (onEnter) {
          onEnter()
        }
      }

      return
    }

    if (
      e.key === "Backspace" &&
      !value[index] &&
      index > 0
    ) {
      if (inputsRef.current[index - 1]) {
        inputsRef.current[index - 1].focus()
      }

      return
    }

    if (
      e.key === "ArrowLeft" &&
      index > 0
    ) {
      if (inputsRef.current[index - 1]) {
        inputsRef.current[index - 1].focus()
      }

      return
    }

    if (
      e.key === "ArrowRight" &&
      index < length - 1
    ) {
      if (inputsRef.current[index + 1]) {
        inputsRef.current[index + 1].focus()
      }
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()

    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, length)

    updateValue(pasted)

    const focusIndex = Math.min(
      pasted.length,
      length - 1
    )

    if (inputsRef.current[focusIndex]) {
      inputsRef.current[focusIndex].focus()
    }
  }

  return (
    <div
      className="otp-wrapper"
      onPaste={handlePaste}
    >
      {Array.from({ length }).map((_, index) => (
        <Input
          key={index}
          ref={(el) => {
            inputsRef.current[index] = el
          }}
          value={value[index] || ""}
          disabled={disabled}
          maxLength={1}
          inputMode="numeric"
          autoComplete="one-time-code"
          onChange={(e) => {
            handleChange(
              e.target.value,
              index
            )
          }}
          onKeyDown={(e) => {
            handleKeyDown(e, index)
          }}
          className="otp-input"
        />
      ))}
    </div>
  )
}

export default OtpInput